import { combineReducers } from 'redux';
import organization from './organizationReducer';
import admin from './adminReducer';
import auth from './authReducer';
import rates from './rateReducer';

const rootReducer = combineReducers({
  auth,
  organization,
  admin,
  rates,
});

export default rootReducer;
